export default "__VITE_ASSET__$cFBHKlJ__"